import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierList from '../components/lists/CarrierList';
import { useCarriers } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminCarriersPage = ({ disableLayout, routes }) => {
  const { allCarriers } = useCarriers();

  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / Carriers" />
      <CarrierList carriers={allCarriers} id="carriers" />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminCarriersPage;
